/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Auth } from 'app/scripts/db/Auth';
import { Board } from 'app/scripts/models/board';
import {
  boxClientId,
  dropboxClientAppKey,
  oneDriveClientId,
  siteDomain,
} from '@trello/config';
import { ApiError } from '@trello/error-handling';
import { Card } from 'app/scripts/models/card';
import { GoogleApi } from 'app/scripts/lib/google-api';
import { AttachmentLimitExceededError as LimitExceeded } from 'app/scripts/views/attachment/AttachmentLimitExceededError';
import { AttachmentTypeRestrictedError as TypeRestricted } from 'app/scripts/views/attachment/AttachmentTypeRestrictedError';
import limitExceededTemplate from 'app/scripts/views/templates/popover_limit_exceeded';
import { isSubmitEvent } from '@trello/keybindings';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import Promise from 'bluebird';
import { TrelloCompleterView } from 'app/scripts/views/internal/autocomplete/TrelloCompleterView';
import { UploadingLinkView } from 'app/scripts/views/card/UploadingLinkView';
import { Util } from 'app/scripts/lib/util';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('attachment_type_picker');
import { Analytics } from '@trello/atlassian-analytics';
import { ninvoke } from 'app/scripts/lib/util/ninvoke';
import customError from '@atlassian/trello-error-ext';
import { pastedFileName } from 'app/scripts/views/internal/pastedFileName';
import { parseTrelloUrl } from 'app/scripts/lib/util/url/parse-trello-url';
import { dontUpsell } from '@trello/browser';
import { Tooltip } from 'app/scripts/views/lib/Tooltip';
import React from 'react';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { UpgradeSmartComponent } from 'app/src/components/UpgradePrompts';
import { showFlag } from '@trello/nachos/experimental-flags';
import { ExternalLinkIcon } from '@trello/nachos/icons/external-link';
import { forTemplate } from '@trello/i18n';

const format = forTemplate('popup_blocked');
const { l } = require('app/scripts/lib/localize');
const { TacoIcon } = require('@trello/nachos/icons/taco');

// eslint-disable-next-line @trello/enforce-variable-case
const FileTooLarge = customError('AttachmentTypePickerView::FileTooLarge');

const template = t.renderable(function ({
  hasLargeAttachments,
  hasOrganizationData,
  id,
  googleDriveReady,
  tipKey,
  tipData,
  defaultName,
  restrictedAttachmentTypes,
}) {
  if (tipKey == null) {
    tipKey =
      'tip-you-can-drag-and-drop-files-and-links-onto-cards-to-upload-them';
  }
  if (tipData == null) {
    tipData = {};
  }

  t.div(
    '.error.js-file-too-large',
    { style: 'margin: 12px 0 6px; display:none;' },
    function () {
      if (hasLargeAttachments) {
        t.format('that-file-size-exceeds-the-250mb-limit');
      } else if (!hasOrganizationData) {
        t.format('that-file-size-exceeds-the-10mb-limit');
      } else {
        t.div('.attachment-size-limit-upgrade-prompt');
      }
    },
  );

  t.ul('.pop-over-list', function () {
    if (Array.from(restrictedAttachmentTypes).includes('computer')) {
      t.li(() =>
        t.a('.disabled.js-attachment-restricted', { href: '#' }, () =>
          t.format('computer'),
        ),
      );
    } else {
      t.li('.uploader', function () {
        t.a('.fakefile', { href: '#' }, () => t.format('computer'));
        return t.form(
          '.realfile',
          {
            action: `/1/card/${id}/attachments`,
            method: 'post',
            enctype: 'multipart/form-data',
          },
          function () {
            t.input({ type: 'hidden', name: 'token', value: '' });
            t.input({ type: 'hidden', name: 'format', value: 'http' });
            return t.input('.js-attach-file', {
              type: 'file',
              name: 'file',
              tabindex: '-1',
              multiple: 'multiple',
            });
          },
        );
      });
    }

    t.li(function () {
      t.a('.js-attach-card', { href: '#' }, () => t.format('trello'));

      t.li(() =>
        t.a(
          '.js-google-drive-attachment',
          {
            href: '#',
            class: t.classify({
              disabled:
                !googleDriveReady ||
                Array.from(restrictedAttachmentTypes).includes('google-drive'),
              'js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('google-drive'),
            }),
          },
          () => t.format('google-drive'),
        ),
      );

      t.li(() =>
        t.a(
          '.js-dropbox-attachment',
          {
            href: '#',
            class: t.classify({
              'disabled js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('dropbox'),
            }),
          },
          () => t.format('dropbox'),
        ),
      );

      t.li(() =>
        t.a(
          '.js-box-attachment',
          {
            href: '#',
            class: t.classify({
              'disabled js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('box'),
            }),
          },
          () => t.format('box'),
        ),
      );

      return t.li(() =>
        t.a(
          '.js-one-drive-attachment',
          {
            href: '#',
            class: t.classify({
              'disabled js-attachment-restricted': Array.from(
                restrictedAttachmentTypes,
              ).includes('onedrive'),
            }),
          },
          () => t.format('onedrive'),
        ),
      );
    });
  });

  t.hr();

  if (Array.from(restrictedAttachmentTypes).includes('link')) {
    t.ul('.pop-over-list', () =>
      t.li(() =>
        t.a('.disabled.js-attachment-restricted', () =>
          t.format('attach-a-link'),
        ),
      ),
    );
  } else {
    t.label({ for: 'addLink' }, function () {
      t.format('attach-a-link');
    });

    t.input('.attachment-add-link-input.js-attachment-url.js-autofocus', {
      type: 'text',
      id: 'addLink',
      placeholder: t.l('paste-any-link-here-ellipsis'),
    });

    t.div('.js-name-link.hide', function () {
      t.label({ for: 'nameLink' }, function () {
        t.format('link-name');
      });

      return t.input('.attachment-add-link-input.js-attachment-name', {
        type: 'text',
        id: 'nameLink',
        value: defaultName,
      });
    });

    t.input('.js-add-attachment-url', {
      style: 'margin: 0;',
      type: 'submit',
      value: t.l('attach'),
    });
  }

  t.hr();

  t.p('.quiet.u-bottom', function () {
    t.format(tipKey, tipData);
  });
});

class AttachmentTypePickerView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'attach from';

    this.prototype.events = {
      'click .js-google-drive-attachment:not(.disabled)':
        'openGoogleDriveFilePicker',
      'click .js-dropbox-attachment:not(.disabled)': 'openDropboxFilePicker',
      'click .js-one-drive-attachment:not(.disabled)': 'openOneDriveFilePicker',
      'click .js-box-attachment:not(.disabled)': 'openBoxFilePicker',
      'click .js-attach-card': 'attachCard',
      'change .js-attach-file': 'startUpload',
      'click .js-add-attachment-url': 'addUrl',
      'keydown .js-attachment-url': 'keydown',
      'keydown .js-attachment-name': 'keydown',
      'input .js-attachment-url': 'toggleAttachmentNameInput',
      'mouseenter .js-attachment-restricted': 'showRestrictedTooltip',
      'mouseleave .js-attachment-restricted': 'hideRestrictedTooltip',
      'click a[href^="/business-class"]'() {
        return Analytics.sendClickedLinkEvent({
          linkName: 'businessClassLink',
          source: 'cardAttachmentPickerInlineDialog',
        });
      },
    };

    this.prototype._scripts = {
      dropbox: 'https://www.dropbox.com/static/api/1/dropbox.js',
      box: 'https://app.box.com/js/static/select.js',
      oneDrive: 'https://js.live.net/v7.0/OneDrive.js',
    };
  }

  initialize() {
    return this.listenTo(GoogleApi, 'loaded', this.render);
  }

  getCard() {
    if (this.model instanceof Card) {
      return this.model;
    } else {
      return this.model.getCard();
    }
  }

  getData() {
    // We're trying to delay loading these scripts, to reduce the chance that
    // they'll cause problems on the client; unfortunately we need to load them
    // prior to the user trying to upload a file from that service, otherwise
    // any popup windows they try to open will be blocked (i.e. if we try to
    // asynchronously load a script between the time they click and when we start
    // the associated picker)
    for (const key in this._scripts) {
      const scriptUrl = this._scripts[key];
      this._loadOnce(scriptUrl, function () {});
    }
  }

  render() {
    const card = this.getCard();
    const board = card?.getBoard();
    if (!card?.canAttach()) {
      if (card?.isOverLimit('attachments', 'perCard')) {
        this.$el.html(limitExceededTemplate('perCard'));
      } else if (board?.isOverLimit('attachments', 'perBoard')) {
        this.$el.html(limitExceededTemplate('perBoard'));
      }
      return this;
    }

    const data = {
      id: card?.id,
      hasLargeAttachments: board?.isFeatureEnabled('largeAttachments') || false,
      hasOrganizationData: Boolean(board?.getOrganization()),
      googleDriveReady: GoogleApi.loaded,
      defaultName: this.options.defaultName,
      restrictedAttachmentTypes: board?.getRestrictedAttachmentTypes() || [],
    };

    this.$el.html(template(data));

    const container = this.el.querySelector(
      '.attachment-size-limit-upgrade-prompt',
    );
    this.unmountAttachmentUpgradePrompt = container
      ? renderComponent(
          <UpgradeSmartComponent
            orgId={board?.get('idOrganization')}
            promptId="attachmentSizeLimitUpgradePromptFull"
            allowUpsell={!dontUpsell()}
          />,
          container,
        )
      : undefined;

    return this;
  }

  remove() {
    this.unmountAttachmentUpgradePrompt?.();
  }

  startUpload(e) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $input = $(e.target);

    // eslint-disable-next-line @trello/enforce-variable-case
    const $tooLarge = $('.js-file-too-large', this.$el).hide();
    const files = _.toArray($input[0].files);
    const { options } = this;

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromComputerLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });
    const source = 'cardAttachmentPickerInlineDialog';
    const analyticsPayload = {
      source,
      taskName: 'create-attachment/file',
    };
    const traceId = Analytics.startTask(analyticsPayload);
    analyticsPayload.traceId = traceId;

    if (options.onStartUpload) {
      options.onStartUpload();
    }

    const board = this.getCard()?.getBoard();
    const upload =
      files.length > 0
        ? _.any(files, (file) => !Auth.me().canUploadAttachment(file, board))
          ? Promise.reject(FileTooLarge())
          : Promise.resolve(files).each((file, index) => {
              // There may be an @options.defaultName, but we don't want to use
              // it because we want to keep the file extension
              const name = file.name || pastedFileName();
              return ninvoke(this.getCard(), 'upload', file, name, {
                numOfFiles: files.length,
                fileIdx: index + 1,
              }).then(
                (response) => {
                  if (traceId) {
                    Analytics.sendTrackEvent({
                      source,
                      action: 'uploaded',
                      actionSubject: 'attachment',
                      actionSubjectId: 'fileAttachment',
                      attributes: {
                        taskId: traceId,
                      },
                    });

                    Analytics.taskSucceeded(analyticsPayload);
                  }

                  return this.trigger('attach', {
                    mimeType: response.mimeType,
                    name: this.options.defaultName || name,
                    url: response.url,
                  });
                },
                (err) => {
                  if (traceId) {
                    analyticsPayload.error = err;
                    Analytics.taskFailed(analyticsPayload);
                  }

                  return Promise.reject(err);
                },
              );
            })
        : // Doesn't support the file API, use form based upload
          ninvoke(Util, 'uploadFile', Auth.myToken(), $input);

    return upload
      .then(function () {
        Analytics.sendOperationalEvent({
          action: 'completed',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
        });
        showFlag({
          title: l('alerts.finished uploading files'),
          icon: <TacoIcon />,
          id: 'AjaxQueueUpload',
          msTimeout: 2000,
        });
        PopOver.hide();
        if (options.onFinishUpload) {
          return options.onFinishUpload();
        }
      })
      .catch(FileTooLarge, function () {
        $tooLarge.show();
        if (options.onFinishUpload) {
          options.onFinishUpload();
        }
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'file too large',
          },
        });
      })
      .catch(LimitExceeded, () => {
        this.render();
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'limit exceeded',
          },
        });
      })
      .catch(TypeRestricted, () => {
        PopOver.hide();
        if (options.onFinishUpload) {
          options.onFinishUpload();
        }
        Alerts.show(
          'attachment upload restricted',
          'error',
          'attachment',
          5000,
        );
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'restricted by enterprise',
          },
        });
      })
      .catch(ApiError.NoResponse, () => {
        // There was a network error
        PopOver.hide();
        options.onFinishUpload?.();
        Alerts.show('unable to upload file', 'error', 'upload', 5000);
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'other',
          },
        });
      })
      .done();
  }

  _loadOnce(scriptUrl, next) {
    if (window._loadedScripts == null) {
      window._loadedScripts = {};
    }
    if (window._loadedScripts[scriptUrl]) {
      return next();
    }

    return $.getScript(scriptUrl, () => {
      window._loadedScripts[scriptUrl] = true;
      return next();
    });
  }

  attachLinks(type, objs, normalize) {
    if (!objs) {
      return;
    }
    $('.js-limit-exceeded', this.$el).toggleClass('hide', true);
    this.options.onStartUpload && this.options.onStartUpload(this.model, type);

    PopOver.pushView({
      view: UploadingLinkView,
    });
    return Promise.resolve(objs)
      .call('map', normalize != null ? normalize : (o) => o)
      .each((file) => {
        const data = _.pick(file, 'url', 'mimeType', 'name');
        this.trigger('attach', data);
        return Promise.fromNode((next) =>
          this.getCard().uploadUrl(data, next),
        ).then((response) => {
          return Analytics.sendOperationalEvent({
            action: 'completed',
            actionSubject: 'upload',
            source: 'cardAttachmentPickerInlineDialog',
            attributes: {
              type,
            },
          });
        });
      })
      .then(() => {
        return PopOver.hide();
      })
      .catch(LimitExceeded, () => {
        PopOver.popView(); // Pop the `UploadingLinkView`
        this.render(); // Re-render to show the limit exceeded error
        return Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'limit exceeded',
          },
        });
      })
      .catch(TypeRestricted, () => {
        Alerts.show('link type restricted', 'error', 'attachment', 5000);
        Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'upload',
          source: 'cardAttachmentPickerInlineDialog',
          attributes: {
            reason: 'type restricted',
          },
        });
        return PopOver.hide();
      })
      .finally(() => {
        return (
          this.options.onFinishUpload &&
          this.options.onFinishUpload(this.model, type)
        );
      })
      .done();
  }

  openGoogleDriveFilePicker(e) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromGoogleDriveLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    return ninvoke(window.gapi, 'load', 'picker')
      .then(function () {
        // If we received an oauth token in the past, we can do a background
        // request to refresh it, since it will not spawn a popup window.
        const refresh = GoogleApi.validToken();
        return ninvoke(GoogleApi, 'authorize', refresh);
      })
      .then((oauthToken) => {
        // Use a docs view that shows folders
        const docsView = new window.google.picker.DocsView();
        docsView.setIncludeFolders(true);

        const teamDrivesView = new window.google.picker.DocsView();
        teamDrivesView.setIncludeFolders(true);
        teamDrivesView.setSelectFolderEnabled(true);
        teamDrivesView.setEnableTeamDrives(true);

        const picker = new window.google.picker.PickerBuilder()
          .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
          .enableFeature(window.google.picker.Feature.SUPPORT_TEAM_DRIVES)
          .addView(docsView)
          .addView(teamDrivesView)
          .setOAuthToken(oauthToken)
          .setCallback((data) => {
            return this.attachLinks('Google drive file', data.docs);
          })
          .build();

        picker.setVisible(true);
        // Fix ridiculous google drive bug
        return $('iframe.picker-frame[src*=authserviceid]').attr(
          'src',
          function () {
            return $(this)
              .attr('src')
              .replace(/authserviceid/g, 'fixgoogle');
          },
        );
      })
      .catch((err) => {
        switch (err.message) {
          case 'popup_closed_by_user':
            // The user closed the popup before finishing the sign in flow.
            break;
          case 'access_denied':
            // The user denied the permission to the scopes required.
            break;
          case 'popup_blocked_by_browser':
            // The browser's popup blocker prevented opening the singin window
            // On first click of "Google Drive", Safari and Firefox throw this error. Second click opens popup
            showFlag({
              id: 'googleSignInError',
              title: format('google-sign-in-error'),
              description: (
                <>
                  <div>{format('try-again-or-support')}</div>
                  <div>
                    <a
                      href="https://help.trello.com/article/1331-trouble-attaching-from-google-drive"
                      target="_blank"
                    >
                      {format('visit-support')} <ExternalLinkIcon />
                    </a>
                  </div>
                </>
              ),
              appearance: 'error',
            });
            break;
          case 'idpiframe_initialization_failed':
            // When not currently signed in to a Google account, Chrome throws this error everytime and will not open the sign in window
            showFlag({
              id: 'googleSignInError',
              title: format('google-sign-in-error'),
              description: (
                <>
                  <div>{format('try-again-or-support')}</div>
                  <div>
                    <a
                      href="https://help.trello.com/article/1331-trouble-attaching-from-google-drive"
                      target="_blank"
                    >
                      {format('visit-support')} <ExternalLinkIcon />
                    </a>
                  </div>
                </>
              ),
              appearance: 'error',
            });
            break;
          default:
            throw err;
        }
      })
      .done();
  }

  openDropboxFilePicker(e) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromDropboxLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    this._loadOnce(this._scripts.dropbox, () => {
      window.Dropbox.init({ appKey: dropboxClientAppKey });
      window.Dropbox.choose({
        linkType: 'preview',
        iframe: true,
        success: (files) => {
          return this.attachLinks('Dropbox file', files, (file) => ({
            url: file.link,
            name: file.name,
          }));
        },
      });

      // The overlay that dropbox creates isn't scrollable, so if your window
      // isn't very tall you can't click the cancel button.  This hack fixes
      // this situation by finding the chooser iframe and making the parent
      // scrollable
      $('iframe[src^="https://www.dropbox.com/chooser"]')
        .parent()
        .css('overflow', 'auto');
    });
  }

  openOneDriveFilePicker(e) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromOneDriveLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    this._loadOnce(this._scripts.oneDrive, () => {
      Promise.try(
        () =>
          new Promise(function (resolve, reject) {
            const { OneDrive } = window;
            return OneDrive.open({
              clientId: oneDriveClientId,
              action: 'share',
              multiSelect: true,
              // If this is false, it takes over the whole window … not an overlay
              openInNewWindow: true,
              success(response) {
                return resolve(response.value);
              },
              cancel() {
                return resolve([]);
              },
              error(err) {
                return reject(err);
              },
              advanced: {
                redirectUri: `${siteDomain}/onedrive_callback_7.html`,
              },
            });
          }),
      )
        .then((files) => {
          return this.attachLinks('OneDrive file', files, (file) => ({
            url: file.webUrl,
            name: file.name,
          }));
        })
        .done();
    });
  }

  openBoxFilePicker(e) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromBoxLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    return this._loadOnce(this._scripts.box, () => {
      const boxSelect = new window.BoxSelect({
        clientId: boxClientId,
        linkType: 'shared',
        multiselect: true,
      });

      const boxSuccess = (files) => {
        boxSelect.unregister(boxSelect.SUCCESS_EVENT_TYPE, boxSuccess);
        return this.attachLinks('Box file', files);
      };

      boxSelect.success(boxSuccess);

      return boxSelect.launchPopup();
    });
  }

  keydown(e) {
    if (isSubmitEvent(e)) {
      return this.addUrl();
    }
  }

  addUrl(e) {
    let urls = $('.js-attachment-url', this.$el).val().split(/\s+/);
    let name = $('.js-attachment-name', this.$el).val();
    if (!/\S/.test(name)) {
      name = undefined;
    }

    Analytics.sendClickedButtonEvent({
      buttonName: 'attachLinkButton',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    urls = _.filter(urls, (url) => /\S/.test(url));

    if (!_.isEmpty(urls) && urls.length < 10) {
      this.attachLinks('link', urls, (url) => ({ url, name }));
    }
  }

  attachCard(e) {
    Analytics.sendClickedLinkEvent({
      linkName: 'attachFromTrelloLink',
      source: 'cardAttachmentPickerInlineDialog',
      containers: this.getCard().getAnalyticsContainers(),
    });

    const trelloCompleterView = new TrelloCompleterView({
      model: this.model,
      card: this.model,
      modelCache: this.modelCache,
      button: true,
      onStartUpload: (item) => {
        let url;
        if (item instanceof Card) {
          url = item.get('url');
          return this.attachLinks('card', [{ url }]);
        } else if (item instanceof Board) {
          url = item.get('url');
          return this.attachLinks('board', [{ url }]);
        }
      },
    });

    return PopOver.pushView({
      view: trelloCompleterView,
    });
  }

  toggleAttachmentNameInput(e) {
    const url = $(e.currentTarget).val();
    const { type } = parseTrelloUrl(url);
    const isTrelloAttachment = ['board', 'card'].includes(type);
    const isEmpty = !/\S/.test(url);
    return $('.js-name-link', this.$el).toggleClass(
      'hide',
      isTrelloAttachment || isEmpty,
    );
  }

  showRestrictedTooltip(e) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $el = $(e.target, this.$el);
    return Tooltip.show(
      t.l('attachment-type-restricted'),
      $el,
      false,
      Tooltip.STYLE.MENU,
    );
  }

  hideRestrictedTooltip() {
    return Tooltip.hide();
  }
}

AttachmentTypePickerView.initClass();
export { AttachmentTypePickerView };
